import { GamesService } from '../Services/games.service';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { JwPaginationComponent } from 'jw-angular-pagination';



@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.css']
})
export class FeaturesComponent implements OnInit {
  games_list: Array<any>;
  filterGames_list: Array<any>;
  cat_games = 'all';
  allVendors: Array<any>;
  vendor_games = 'all';
  cats = [];
  items = [];
  filterWord: string;
  featureState: boolean;
  activeClass: boolean;
  porgressBar: boolean;
  porgress = 1;
  
  // current page of items
  pageOfItems: Array<any>;
  paginate: { itemsPerPage: 50}



  constructor(private games: GamesService) {
    // this.getGames();
    this.getgames();
    this.getAllCats();
   
  }


  ngOnInit() {
   
    this.porgressBar = true
    this.games.getAllVendors().subscribe(
      next => {
        console.log(next)
        this.allVendors = next['user_lists'];
        this.porgressBar = false

      },
      error => { console.log(error);
        this.porgressBar = false }
    
    )

  }

  //get all games 
  getGames() {
    this.games.getgames().subscribe(
      next => {
        console.log(next)
        this.games_list = next['games_list'];
        this.filterGames_list = this.games_list
      },
      error => { console.log(error) }
    )
  }



  //get the list of games 
  getgames() {
    this.games.getMygames('uLHFM17DNN').subscribe(
      next => {
        console.log(next);
        this.games_list = next['games_list'];
        this.filterGames_list = this.games_list
        // this.games_top=next['top']
      },
      error => { console.log(error) }
    )
  }


  //adding this game to the world cup

  world($ev) {
    console.log($ev.target.checked);
    console.log($ev.target.value);

    if ($ev.target.checked) {
      this.games.addWorldGame($ev.target.value).subscribe(
        next => { console.log(next) },
        error => { console.log(error) }
      )
    }
    else {
      this.games.deleteWorldGame($ev.target.value).subscribe(
        next => { console.log(next) },
        error => { console.log(error) }
      )
    }



  }

  //adding this game to exclusive

  excluisve($ev) {
    console.log($ev.target.checked);
    console.log($ev.target.value);
    if ($ev.target.checked) {
      this.games.addFeautreGame($ev.target.value, 'exclusive').subscribe(
        next => { console.log(next) },
        error => { console.log(error) }
      )
    }
    else {
      this.games.deleteFeautreGame($ev.target.value, 'exclusive').subscribe(
        next => { console.log(next) },
        error => { console.log(error) }
      )
    }

  }



  recommended($ev) {
    console.log($ev.target.checked);
    console.log($ev.target.value);
    if ($ev.target.checked) {
      this.games.addFeautreGame($ev.target.value, 'recommended').subscribe(
        next => { console.log(next) },
        error => { console.log(error) }
      )
    }
    else {
      this.games.deleteFeautreGame($ev.target.value, 'recommended').subscribe(
        next => { console.log(next) },
        error => { console.log(error) }
      )
    }
  }

  Subway($ev) {
    console.log($ev.target.checked);
    console.log($ev.target.value);
    if ($ev.target.checked) {
      this.games.addFeautreGame($ev.target.value, 'subway').subscribe(
        next => { console.log(next) },
        error => { console.log(error) }
      )
    }
    else {
      this.games.deleteFeautreGame($ev.target.value, 'subway').subscribe(
        next => { console.log(next) },
        error => { console.log(error) }
      )
    }
  }






  top($ev) {
    console.log($ev.target.checked);
    console.log($ev.target.value);
    if ($ev.target.checked) {
      this.games.addFeautreGame($ev.target.value, 'top_games').subscribe(
        next => { console.log(next) },
        error => { console.log(error) }
      )
    }
    else {
      this.games.deleteFeautreGame($ev.target.value, 'top_games').subscribe(
        next => { console.log(next) },
        error => { console.log(error) }
      )
    }


  }




  trend($ev) {
    console.log($ev.target.checked);
    console.log($ev.target.value);
    if ($ev.target.checked) {
      this.games.addFeautreGame($ev.target.value, 'trend_games').subscribe(
        next => { console.log(next) },
        error => { console.log(error) }
      )
    }
    else {
      this.games.deleteFeautreGame($ev.target.value, 'trend_games').subscribe(
        next => { console.log(next) },
        error => { console.log(error) }
      )
    }



  }



  top_rate($ev) {
    console.log($ev.target.checked);
    console.log($ev.target.value);
    if ($ev.target.checked) {
      this.games.addFeautreGame($ev.target.value, 'top_rated').subscribe(
        next => { console.log(next) },
        error => { console.log(error) }
      )
    }
    else {
      this.games.deleteFeautreGame($ev.target.value, 'top_rated').subscribe(
        next => { console.log(next) },
        error => { console.log(error) }
      )
    }



  }


  popular($ev) {
    console.log($ev.target.checked);
    console.log($ev.target.value);
    if ($ev.target.checked) {
      this.games.addFeautreGame($ev.target.value, 'popular_games').subscribe(
        next => { console.log(next) },
        error => { console.log(error) }
      )
    }
    else {
      this.games.deleteFeautreGame($ev.target.value, 'popular_games').subscribe(
        next => { console.log(next) },
        error => { console.log(error) }
      )
    }



  }

  under_25M($ev) {
    console.log($ev.target.checked);
    console.log($ev.target.value);
    if ($ev.target.checked) {
      this.games.addFeautreGame($ev.target.value, 'games_under_25m').subscribe(
        next => { console.log(next) },
        error => { console.log(error) }
      )
    }
    else {
      this.games.deleteFeautreGame($ev.target.value, 'games_under_25m').subscribe(
        next => { console.log(next) },
        error => { console.log(error) }
      )
    }



  }


  new($ev) {
    console.log($ev.target.checked);
    console.log($ev.target.value);
    if ($ev.target.checked) {
      this.games.addFeautreGame($ev.target.value, 'new_games').subscribe(
        next => { console.log(next) },
        error => { console.log(error) }
      )
    }
    else {
      this.games.deleteFeautreGame($ev.target.value, 'new_games').subscribe(
        next => { console.log(next) },
        error => { console.log(error) }
      )
    }



  }





  slider($ev) {
    console.log($ev.target.checked);
    console.log($ev.target.value);

    if ($ev.target.checked) {
      this.games.addSliderGame($ev.target.value).subscribe(
        next => { console.log(next) },
        error => { console.log(error) }
      )
    }
    else {
      this.games.deleteSliderGame($ev.target.value).subscribe(
        next => { console.log(next) },
        error => { console.log(error) }
      )
    }
  }
  // status(id) {
  //   console.log(this.games_list);
  //     this.games.setActiveStatusGame(id).subscribe(
  //       next => {
  //         console.log(next)
  //       },
  //       error => { console.log(error) }
  //     )
  // }


  status(target,id) {
    var result = confirm("Want to change status ?");
if (result) {
    //Logic to delete the item
    if (target =="disactive" ) {
      console.log(target);
      this.games.setActiveStatusGame(id).subscribe(
        next => {
          console.log(next)
         alert("Done game is active");
         window.location.reload()
        },
        error => { console.log(error) 
          alert("some things wrong, please try agine")
        }
        ) }
    else {
      this.games.setDisactiveStatusGame(id).subscribe(
        next => { console.log(next);
          alert("Done game is disactive");
          window.location.reload()
         },
        error => { console.log(error);
          alert("some things wrong, please try agine") }
      )
    }
  }

}
  vendorGame(vender: string) {
    this.vendor_games = vender;
    console.log(this.vendor_games, "this.vendor_games")
  }

  catGame(id) {
    if (id == 'all') {
     
    }
    else {
      this.cat_games = id;
    }

    console.log(id);
  }

  
  search() {
    this.porgressBar = true
   
    var data = new FormData();
    data.append('game_cat', this.cat_games);
    data.append('game_vendor', this.vendor_games);


    this.games.catGames(data).subscribe(
      next => {
        console.log(next),
          this.games_list = next['game_list']
        this.porgressBar = false
      },
      error => { console.log('error') }
    )
    console.log(this.porgress);

  }


    onChangePage(pageOfItems: Array<any>) {
      // update current page of items
      this.pageOfItems = pageOfItems
  }

  filterByVendor(pageOfItems: Array<any>, word: string){
    this.pageOfItems = pageOfItems.filter(game => game.game_vendor.includes(word));
  }


  /**
   * get all
   *@description get all cats from backend 
   */

  getAllCats() {
    this.games.getAllCats().subscribe(next => {
      this.cats = next['cat_lists'];
      console.log(next['cat_lists']);
    }, error => { console.log(error) });
  }

}



//<td> <input type="checkbox" (change)=world($event) [value]="game.game_id" > </td>
//<td> <input type="checkbox"  (change)=editor($event)  value="game.game_id" > </td>



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/features/features.component.ts